module.exports = "<div class=\"users\">\r\n\t<div class=\"filters\">\r\n\t\t<button class=\"btn btn-primary all-users\">All Users</button>\r\n\t\t<button class=\"btn btn-primary unlinked-users\">Unlinked Users</button>\r\n\t\t<button class=\"btn btn-primary linked-users\">Linked Users</button>\r\n\t</div>\r\n\t<div class=\"users-list\">\r\n\t\t\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/users/users.tpl.html
// module id = 46
// module chunks = 0